import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { LOGIN_USER } from './actionTypes';
import { loginSuccess, apiError } from './actions';
import { setAuthenticatedUser } from '../../actions';

import authenticationService from '../../../services/authenticationService';
import authorizationHelper from '../../../helpers/authorizationHelper';

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(authenticationService.logIn, {
      email: user.email,
      password: user.password,
    });

    /**
     * Expected backend response:
     * {
     *   message: "...",
     *   data: {
     *     user: {...},
     *     authToken: "..."
     *   }
     * }
     * Note: authenticationService.logIn() already returns response.data.data
     */
    const loggedInUser = response?.user;
    const authToken = response?.authToken;

    if (!loggedInUser || !authToken) {
      throw new Error('Invalid login response');
    }

    // Admin-only access
    if (!authorizationHelper.isAtLeastAdmin(loggedInUser.role)) {
      throw new Error('Unauthorized login');
    }

    authenticationService.setToken(authToken);
    authenticationService.setLoggedInUser(loggedInUser);

    yield put(loginSuccess(response));
    yield put(
      setAuthenticatedUser({
        user: loggedInUser,
        isAuthenticated: true,
        authToken,
      })
    );

    history.push('/dashboard');
  } catch (error) {
    // Normalize error to string to prevent "undefined is not an object" errors
    const errorMessage = typeof error === 'string' 
      ? error 
      : error?.message || error?.toString() || 'An error occurred during login';
    yield put(apiError(errorMessage));
  }
}

export function* watchUserLogin() {
  yield takeEvery(LOGIN_USER, loginUser);
}

function* authSaga() {
  yield all([fork(watchUserLogin)]);
}

export default authSaga;
